module.exports = __webpack_public_path__ + "static/flowmoji-afl-footy-fixtures_light_RGB-ae45ece01f8a38c4fa37316606e53fd8.svg";